import { IShoppableSite, shoppableSites, ReleaseType, Site } from "./directory";

const getParentPageDataLayerWindow = (window : any): any | undefined => {
    try {
        const dataLayer: any[] = window.top.dataLayer;
        if(dataLayer) {
            const parentWindowObj = dataLayer.find(windowObj => windowObj.event === 'legacyPageview') ||
            dataLayer.find(windowObj => windowObj.event === 'unifiedPageview');

            return parentWindowObj;
        }
    } catch (error) {
        return undefined;
    }
};

const getShoppableSiteFromUrl = (location: Location): IShoppableSite => {
    const split = location.hostname.split('.');
    const siteName = split.length > 2 ? split[1] : split[0];
    const site = shoppableSites.get(siteName) || shoppableSites.get(Site.UNKNOWN)!;
    return site;
};

const getReleaseTypeByUrl = (location: Location): ReleaseType => {
    const { hostname } = location;
    if (hostname.indexOf('0.0.0.0') >= 0 || hostname.indexOf('localhost') >= 0 || hostname.indexOf('127.0.0.1')) {
        return ReleaseType.DEVELOPMENT;
    }

    if (hostname.indexOf('test') >= 0) {
        return ReleaseType.QA;
    }

    const split = hostname.split('.');

    if (hostname.indexOf('www') >= 0 || split.length === 2) {
        // Site missing www. just using https://site.com
        return ReleaseType.PRODUCTION;
    }

    // Dunno, play it safe.
    return ReleaseType.DEVELOPMENT;
};

const getDocumentId = (window : any): string => {
    const parentWindowObj = getParentPageDataLayerWindow(window);
    if(parentWindowObj) {
        return parentWindowObj.karmaId || parentWindowObj.documentId;
    }

    // One last check since we can't find it on the parent page (maybe requestId was passed in a query string)
    const params = new URLSearchParams(window.location.search);
	return params.get('documentId') ?? '0';
};

const getRequestId = (window : any): string | undefined => {
    const parentWindowObj = getParentPageDataLayerWindow(window);
    if(parentWindowObj) {
        return parentWindowObj.requestId || parentWindowObj.internalRequestId;
    }

    // One last check since we can't find it on the parent page (maybe requestId was passed in a query string)
    const params = new URLSearchParams(window.location.search);
	return params.get('requestId') ?? undefined;
};

export {
    getDocumentId,
    getRequestId,
    getReleaseTypeByUrl,
    getShoppableSiteFromUrl,
};
